// extracted by mini-css-extract-plugin
export default {"mCard":"zC-z","image":"AC-z","imageNoBackground":"BC-z","imageHasCategory":"CC-z","fullWidth":"DC-z"};